import { SET_MODAL } from './types';
import { Dispatch } from 'redux';
import * as TYPE from '../Global/types';

export const renderModal = (modal: any) => (dispatch: Dispatch<TYPE.GlobalActions>) =>
  dispatch({ type: SET_MODAL, payload: modal });
